import React, {useState} from 'react';
import OpenModalSelectBillItemToPrint from "../../../../Table/Modals/OpenModalSelectBillItemToPrint";
import {toast} from "react-toastify";

const MyComponent = (props) => {
  const {selectedRow, whichRow} = props

  // چون توی اون کامپوننت
  // OpenModalSelectBillItemToPrint
  // از تاربع  get data
  // استفاده شده اینجا من ااین تابع رو میچسبونم تا مشکلی پیش نیاد.

  const [isOpen, setIsOpen] = useState(false)

  if ((typeof selectedRow) === "string") {
    return <></>
  }

  if (Object.keys(selectedRow).length > 0) {
    selectedRow.getData = () => {
      return selectedRow
    }
  }

  return (
    <>
      <div className="button-styl" onClick={() => {
        if (Object.keys(selectedRow).length === 0) {
          toast("لطفا یک سطر انتخاب کنید")
        } else {
          setIsOpen(true)
        }
      }}>
        <p>صورتحساب</p>
      </div>

      {selectedRow.getData !== undefined && isOpen && <OpenModalSelectBillItemToPrint
        {...props}
        selectedRow={selectedRow}
        isOpen={isOpen}
        modalCallback={() => setIsOpen(false)}
      />}

    </>
  );
};

export default MyComponent;
